import "./index.css";

export const SimpleConditionStringRender = ({ label, value }) => {
  if (Array.isArray(value)) {
    value = value.join(", ");
  }
  return (
    <div className="key-condition-string-container">
      <span className="simple-condition-string-label">{label} is </span>
      <span className="simple-condition-string-value">{value}</span>
    </div>
  );
};
